var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-class"},[_c('v-tabs',{attrs:{"color":"black","dark":"","slider-color":"primary"}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v("Ajouter un utilisateur")])],1),_vm._v(" "),_c('pro-user-form',{model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf3b09ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/proUsers/proUser.add.vue
// module id = null
// module chunks = 